<template>
  <Breadcrumbs
      title="Initial Stock"
      :breadcrumbs="[
      { label: 'Stock', path: '' },
      { label: 'Initial Stock', path: '/initial-stock' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <initialStockForm/>

    </div>
  </div>
</template>


<script>
import initialStockForm from '@/pages/stock/initial_stock/initialStockForm.vue';

export default {
  components: {
    initialStockForm
  }
}
</script>